import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

const FAQ_ITEMS = [
    {
        q: "Czy muszę być na szkoleniu o konkretnej godzinie?",
        a: "Nie. Szkolenia nie są transmitowane na żywo. Otrzymujesz dostęp do nagrań i materiałów, z których możesz korzystać w dogodnym momencie - wtedy, gdy masz czas i spokój.",
    },
    {
        q: "Czy mogę obejrzeć szkolenie później, nie w dniu startu?",
        a: "Tak. Premiera oznacza dzień, w którym materiały pojawiają się na platformie - od tego momentu możesz oglądać je w dowolnym czasie. Standardowy dostęp jest ważny przez 10 miesięcy, chyba że zakup został dokonany w ramach oferty z innymi zasadami.",
    },
    {
        q: "Czy otrzymam certyfikat udziału?",
        a: "Tak. Każdy uczestnik otrzymuje imienny certyfikat ukończenia szkolenia w formacie PDF - idealny do wydruku lub przekazania do szkoły.",
    },
    {
        q: "Czy mogę otrzymać fakturę z odroczonym terminem płatności dla szkoły?",
        a: "Tak. Wystawiamy faktury z odroczonym terminem płatności. Jeśli za udział płaci szkoła, podczas składania zamówienia wystarczy podać jej dane - my zajmiemy się resztą.",
    },
    {
        q: "Czy kurs jest odpowiedni dla osób pracujących indywidualnie?",
        a: "Tak - kurs powstał z myślą o zajęciach indywidualnych, grupowych i firmowych. W programie znajdziesz też rozwiązania typowe dla pracy 1-1, np. jak utrzymać godzinną rozmowę z jednym uczniem.",
    },
    {
        q: "Czy materiały można pobrać?",
        a: "Nagrania i materiały oglądasz na platformie online przez cały okres dostępu - standardowo 10 miesięcy. Do pobrania otrzymujesz imienny certyfikat ukończenia w formacie PDF.",
    },
    {
        q: "Jak długo trwa cały kurs?",
        a: "Kurs to 100 lekcji podzielonych na 5 modułów tematycznych. Oglądasz je w swoim tempie i w dowolnej kolejności - wystarczy otworzyć lekcję o problemie, który aktualnie Cię dotyczy.",
    },
    {
        q: "Czy dostęp działa na telefonie?",
        a: "Tak. Platforma działa na komputerze, tablecie i telefonie - lekcje obejrzysz w drodze do pracy albo w przerwie między zajęciami.",
    },
    {
        q: "Co zrobić w przypadku problemów z logowaniem?",
        a: "Napisz lub zadzwoń do Ewy Siereńskiej: 577 033 633, ewa.sierenska@edunation.com.pl. Ewa pomoże Ci odzyskać dostęp do platformy.",
    },
];

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="py-20 sm:py-28 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                kicker="FAQ"
                title="Najczęstsze pytania o kurs"
            />
            <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="mt-10 space-y-4">
                    {FAQ_ITEMS.map((item, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-accordion-item-${i + 1}`}
                            className="rounded-2xl border-0 bg-cream-deep px-6 data-[state=open]:bg-[#E9FBF7] data-[state=open]:shadow-soft transition-all"
                        >
                            <AccordionTrigger className="text-left font-display font-bold text-ink text-base py-5 min-h-[44px] hover:no-underline">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-sm text-ink-mute leading-relaxed pb-6">
                                {item.a ?? (
                                    <span className="italic text-ink bg-tang/50 rounded-lg px-3 py-2 inline-block">
                                        Odpowiedź do uzupełnienia - pojawi się wkrótce.
                                    </span>
                                )}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
